module.exports = __webpack_public_path__ + "static/media/heuristicevaluation.a24f694a.jpeg";